import { getConfig } from '@universe/config'

export const config = getConfig()
